function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8042"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3031"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 172",
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-touch-app",
  d: "M14.628 15.377v-3.512a2.283 2.283 0 012.209-2.348 2.283 2.283 0 012.21 2.348v3.512a4.288 4.288 0 001.768-3.512 4.1 4.1 0 00-3.977-4.226 4.1 4.1 0 00-3.977 4.226 4.288 4.288 0 001.767 3.512zm8.7 4.348l-4.012-2.122a1.182 1.182 0 00-.477-.1h-.672v-5.638a1.328 1.328 0 10-2.651 0v10.086l-3.031-.676a1.458 1.458 0 00-.212-.028.961.961 0 00-.7.31l-.7.751 4.366 4.639a1.292 1.292 0 00.937.413h6a1.318 1.318 0 001.273-1.2l.663-4.949a1.5 1.5 0 00.018-.188 1.411 1.411 0 00-.8-1.3z",
  fill: "#a1dbd3"
}));
var SvgTouchIconCircle = function SvgTouchIconCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35"
  }, props), _ref);
};
export default SvgTouchIconCircle;